import {
    ExperienceTypeBreakdown,
    VisitTypeBreakdown,
} from '../../types/dashboard';

export enum NewBookingCategoryBreakdown {
    ExperienceType = 'experience-type',
    VisitType = 'visit-type',
}

export type NewBookingCategoryPoint = {
    label: string;
    bookingCount: number;
};

export function experienceBreakdownToPoints(
    breakdown: ExperienceTypeBreakdown,
): NewBookingCategoryPoint[] {
    return [
        { label: 'Boat', bookingCount: breakdown.boat },
        { label: 'Property', bookingCount: breakdown.property },
        { label: 'Activity', bookingCount: breakdown.activity },
        { label: 'Vehicle', bookingCount: breakdown.vehicle },
        { label: 'Commercial', bookingCount: breakdown.commercial },
    ];
}

export function visitBreakdownToPoints(
    breakdown: VisitTypeBreakdown,
): NewBookingCategoryPoint[] {
    return [
        { label: 'Business', bookingCount: breakdown.business },
        { label: 'Personal', bookingCount: breakdown.personal },
        { label: 'Blocked', bookingCount: breakdown.blocked },
    ];
}

export function formatExperienceBreakdown(
    breakdown: ExperienceTypeBreakdown,
): string {
    const parts: string[] = [];

    if (breakdown.boat) {
        parts.push(`${breakdown.boat} boat`);
    }
    if (breakdown.property) {
        parts.push(`${breakdown.property} property`);
    }
    if (breakdown.activity) {
        parts.push(`${breakdown.activity} activity`);
    }
    if (breakdown.vehicle) {
        parts.push(`${breakdown.vehicle} vehicle`);
    }
    if (breakdown.commercial) {
        parts.push(`${breakdown.commercial} commercial`);
    }

    return parts.join(' · ');
}

export function formatVisitBreakdown(breakdown: VisitTypeBreakdown): string {
    const parts: string[] = [];

    if (breakdown.business) {
        parts.push(`${breakdown.business} business`);
    }
    if (breakdown.personal) {
        parts.push(`${breakdown.personal} personal`);
    }
    if (breakdown.blocked) {
        parts.push(`${breakdown.blocked} blocked`);
    }

    return parts.join(' · ');
}
